<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<p class="figcap"><span class="bold">Murray Family Tree</span></p>
<div class="img_container">
<img alt="images" src="images/fviii-01.jpg"/>
</div>
<a id="page_ix"></a>
<p class="figcap"><span class="bold">Hamilton Family Tree</span></p>
<div class="img_container">
<img alt="images" src="images/f00ix-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm.vue?0c3dad67